/**
 * Shopify の承認画面を埋め込み iframe の外へ出して開く。
 *
 * `confirmationUrl` は管理画面のトップレベルで開く必要がある。Shopify の
 * Navigation API が外部 URL の現在ウィンドウ遷移に指定する `_top` を使う。
 * 呼び出し側から分離し、jsdom テストではこの関数だけを mock できるようにする。
 */
export function redirectTopLevel(url: string): void {
  window.open(url, "_top");
}
